import { BackgroundAnimation } from './components/common/BackgroundAnimation.js';
import { Sidebar } from './components/common/Sidebar.js';
import { Header } from './components/common/Header.js';
import { SettingsModal } from './components/common/SettingsModal.js';
import { AccessibilityModal } from './components/common/AccessibilityModal.js';
import { AcademicCategoriesModal } from './components/common/AcademicCategoriesModal.js';
import { TimeSelectionModal } from './components/common/TimeSelectionModal.js';
import { MusicSelectionModal } from './components/common/MusicSelectionModal.js';
import { RadioModal } from './components/common/RadioModal.js';

// Export for controlled initialization
export function renderLayout() {
    // OLD: All screens were rendered here (heavy load)
    // NEW: Screens are rendered dynamically by Router.js when needed

    // Construct the main game container content (Initially Empty)
    const gameContainerContent = `
        ${Header()}
        <!-- Screens will be injected here dynamically -->
    `;

    // Construct the root content (Background, Sidebar, GameContainer, Modals)
    const rootContent = `
        ${BackgroundAnimation()}
        ${Sidebar()}
        <div id="game-container">
            ${gameContainerContent}
        </div>
        ${SettingsModal()}
        ${AccessibilityModal()}
        ${AcademicCategoriesModal()}
        ${TimeSelectionModal()}
        ${MusicSelectionModal()}
        ${RadioModal()}
    `;

    // Inject into body at the beginning (preserving scripts at the end)
    document.body.insertAdjacentHTML('afterbegin', rootContent);
}
